<template>
  <div class="w-100">
    <v-data-table
      hide-default-header
      mobile-breakpoint="0"
      :headers="
        headers.filter((item) => {
          return getReportColumn(item.value);
        })
      "
      :items="
        getReportsSearchQuery
          ? projectId &&
            projectId.users.filter((item) => {
              return item.name
                ? item.name
                    .toLowerCase()
                    .includes(getReportsSearchQuery.name.toLowerCase())
                : item.email
                    .toLowerCase()
                    .includes(getReportsSearchQuery.email.toLowerCase());
            })
          : projectId && projectId.users
      "
      class="mb-1 mt-0"
      :class="
        tableHeight && tableHeight.length && tableHeight.length == 1
          ? ''
          : 'y-scroll child-table'
      "
      hide-default-footer
      :items-per-page="500"
    >
      <!-- Icon for expanding -->
      <template v-slot:[`item.data-table-expand`]="{ item }">
        <div class="d-flex align-center">
          <div style="width: 50px">
            <v-chip
              width="50"
              class="px-1"
              v-if="isArchived(item.id)"
              outlined
              x-small
              >Archived</v-chip
            >
          </div>
        </div>
      </template>
      <!-- Name Column -->
      <template v-slot:[`item.name_email`]="{ item }">
        <div @click="redirect(item, 'all')" class="w-1 py-0 pointer">
          <span class="d-flex justify-content-center">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              content-class="ma-0 pa-0 tooltip-opacity"
              open-delay="300"
              right
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <profileImage
                    v-show="item.image ? ':src' : ':username'"
                    :src="item.image"
                    inline
                    :username="item.name ? item.name : item.email"
                    :size="28"
                    :userProfile="true"
                    :circular="true"
                  >
                  </profileImage>
                </div>
              </template>

              <!-- Display User info on hover -->
              <UserInfo
                :image="item.image"
                :name="item.name"
                :email="item.email"
                :role="
                  getAllMembers &&
                    getAllMembers.find((user) => {
                      return user.id == item.id;
                    }).role
                "
              />
            </v-tooltip>
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              content-class="arrow-up"
              color="#DCD8F3"
              bottom
            >
              <template v-slot:activator="{ on }">
                <div
                  style="max-width: 100px"
                  class="d-inline-block text-truncate ml-3 mt-1"
                  :class="item.name ? 'text-capitalize' : ''"
                  v-on="on"
                >
                  {{ item.name ? item.name : item.email }}
                </div>
              </template>
              <div class="text-capitalize font-weight-bold dark-purple-text">
                {{ item.name ? item.name : item.email }}
              </div>
            </v-tooltip>
          </span>
        </div>
      </template>

      <!-- Department Column -->
      <template v-slot:[`item.department`]="{ item }">
        <div class="w-1 pointer">
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            content-class="arrow-up"
            color="#DCD8F3"
            bottom
          >
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                :class="item.department ? '' : 'caption grey--text font-italic'"
                class="text-capitalize pointer d-inline-block text-truncate"
                style="max-width: 120px"
              >
                {{ item.department ? item.department : "No department" }}
              </span>
            </template>
            <span class="text-capitalize font-weight-bold dark-purple-text">
              {{ item.department ? item.department : "No department" }}</span
            >
          </v-tooltip>
        </div>
      </template>

      <!-- Designation Column -->
      <template v-slot:[`item.designation`]="{ item }">
        <div class="w-1 pointer">
          <v-tooltip
            :disabled="$vuetify.breakpoint.xs"
            content-class="arrow-up"
            color="#DCD8F3"
            bottom
          >
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                :class="
                  item.designation ? '' : 'caption grey--text font-italic'
                "
                class="text-capitalize pointer d-inline-block text-truncate font-weight-bold dark-purple-text"
                style="max-width: 120px"
              >
                {{ item.designation ? item.designation : "No designation" }}
              </span>
            </template>
            <span class="text-capitalize font-weight-bold dark-purple-text">
              {{ item.designation ? item.designation : "No designation" }}</span
            >
          </v-tooltip>
        </div>
      </template>

      <!-- Pending Column -->
      <template v-slot:[`item.pending`]="{ item }">
        <div @click="redirect(item, 'pending')" class="w-1 py-0 pointer">
          <v-chip
            class="count-status-chip d-flex justify-center pointer"
            label
            small
            dark
            color="yellow-chip-color"
          >
            <span>
              {{ item.pending }}
            </span>
          </v-chip>
        </div>
      </template>
      <!-- Completed Column -->
      <template v-slot:[`item.completed`]="{ item }">
        <div @click="redirect(item, 'completed')" class="w-1 py-0 pointer">
          <v-chip
            class="count-status-chip d-flex justify-center pointer"
            label
            small
            dark
            color="green-chip-color"
          >
            <span>
              {{ item.completed }}
            </span>
          </v-chip>
        </div>
      </template>
      <!-- Overdue Column -->
      <template v-slot:[`item.overdue`]="{ item }">
        <div @click="redirect(item, 'overdue')" class="w-1 py-0 pointer">
          <v-chip
            class="count-status-chip d-flex justify-center pointer"
            label
            small
            dark
            color="red-chip-color"
          >
            <span>
              {{ item.overdue }}
            </span>
          </v-chip>
        </div>
      </template>
      <!-- Total time column -->
      <template v-slot:[`item.total_time`]="{ item }">
        <div class="w-4 py-0">
          <span dark>
            {{ item.total_time }}
          </span>
        </div>
      </template>

      <!-- Action Column -->
      <template v-slot:[`item.action`]="{ item }">
        <!-- info icon -->
        <v-layout class="d-flex justify-end px-3">
          <div>
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              color="#DCD8F3"
              content-class="arrow-up"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-hover>
                  <v-icon
                    v-on="on"
                    v-bind="attrs"
                    class="dark-purple-text mr-6"
                    small
                    @click="taskEntries(item)"
                  >
                    mdi-information-outline</v-icon
                  >
                </v-hover>
              </template>
              <span class="font-weight-bold dark-purple-text">
                Task Details</span
              >
            </v-tooltip>
          </div>
        </v-layout>
      </template>
    </v-data-table>
    <template v-if="openMemberTasksModal">
      <TasksModal
        :openMemberTasksModal.sync="openMemberTasksModal"
        :fetchTaskEntriesLoader.sync="fetchTaskEntriesLoader"
      />
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import profileImage from "@/components/Includes/ProfileImage";
import UserInfo from "@/components/TeamMembers/UserInfo";
import moment from "moment";
export default {
  name: "ProjectMemberEntries",
  props: [
    "projectHeaders",
    "projectId",
    "dateRange",
    "getReportsDate",
    "tableHeight",
  ],
  components: {
    profileImage,
    UserInfo,
    TasksModal: () => import("@/components/Reports/TasksModal"),
  },
  data() {
    return {
      allTheTime: null,
      openMemberTasksModal: false,
      fetchTaskEntriesLoader: false,
      headers: [
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          class: "light-purple-bg",
          cellClass: "pl-2 pr-0",
        },
        {
          text: "Name",
          value: "name_email",
          sortable: false,
          class: "light-purple-bg px-0",
          cellClass: "px-0",
          width: "80px",
        },
        {
          text: "Designation",
          value: "designation",
          sortable: false,
          class: "light-purple-bg px-0",
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Department",
          value: "department",
          sortable: false,
          class: "light-purple-bg px-0",
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Completed",
          value: "completed",
          class: "light-purple-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Pending",
          value: "pending",
          class: "light-purple-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Overdue",
          value: "overdue",
          class: "light-purple-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Total time",
          value: "total_time",
          class: "light-purple-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
        {
          text: "Action",
          value: "action",
          class: "light-purple-bg px-0",
          sortable: false,
          cellClass: "px-0",
          width: "100px",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getAllMembers",
      "getSelectedCompany",
      "getReportsSearchQuery",
      "isArchived",
      "getReportColumn",
    ]),
  },
  methods: {
    // Redirection to Task Page
    redirect(item, status) {
      this.allTheTime = ["2000-01-01", moment().format("YYYY-MM-DD")];
      this.$store.commit("setTaskFilter", {
        status,
        assigned_to: [item],
        start_date:
          status == "pending" || status == "overdue"
            ? this.allTheTime[0]
            : this.dateRange[0],
        end_date:
          status == "pending" || status == "overdue"
            ? this.allTheTime[1]
            : this.dateRange[1],
        show_tasks: this.getSelectedCompany.role == "employee" ? "me" : "all",
        redirect: status == "pending" ? true : false,
        page: 1,
        title: null,
        project_id: [this.projectId.id],
        assigned_by: [],
        report: false,
      });
      this.$store.commit(
        "setTaskDateFilter",
        status == "pending" || status == "overdue"
          ? "All time"
          : this.getReportsDate
      );
      localStorage.setItem("redirection", true);
      window.open("task");
    },
    taskEntries(item) {
      this.openMemberTasksModal = true;
      this.fetchTaskEntriesLoader = true;
      this.$store
        .dispatch("fetchReportsTasksByTimeEntries", {
          company_id: this.getSelectedCompany.id,
          user_id: item.id,
          project_id: this.projectId.id,
          start_date: this.dateRange[0],
          end_date: this.dateRange[1],
          status: this.getReportsStatus,
        })
        .finally(() => {
          this.fetchTaskEntriesLoader = false;
        });
    },
  },
};
</script>
<style scoped>
.w-1 {
  width: 190px !important;
}

.w-4 {
  width: 220px !important;
}
.child-table {
  max-height: 190px;
}
</style>
